// `\includegraphics[options]{url}`; options may hold `{...}` groups like alt={}.
const INCLUDEGRAPHICS_OPTIONS =
  /\\includegraphics\[((?:[^\][{}]|\{[^{}]*\})*)\]/g
const ALT_OPTION = /\s*alt=\{[^{}]*\}\s*,?/g

/**
 * Drops the `alt={...}` option from `\includegraphics[...]`.
 *
 * Mathpix emits `\includegraphics[alt={},max width=\textwidth]{url}`, and
 * mathpix-markdown-it cannot parse the braces inside the options: the figure
 * renders as the raw text `,max width=\textwidth]{url}` instead of the image
 * (uploaded paper, 9 Oct 2026). Runs at render time, so stored papers are
 * covered too.
 */
export const stripIncludegraphicsAlt = (content: string): string => {
  if (!content || !content.includes('alt=')) return content

  return content.replace(INCLUDEGRAPHICS_OPTIONS, (whole, options: string) => {
    if (!options.includes('alt=')) return whole

    const rest = options.replace(ALT_OPTION, '').replace(/,\s*$/, '').trim()

    return rest ? `\\includegraphics[${rest}]` : '\\includegraphics'
  })
}
